import {
  ArrowRightOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Empty, message, Popconfirm, Table, Tooltip } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { translate } from "../../locale";
import CompanyServices from "../../services/CompanyServices";
import ProtocolServices from "../../services/ProtocolServices";
import CellButton from "../Buttons/CellButton";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ProtocolAssociatedCoTable = ({ reload, protocol }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (text, record, index) => (
        <div className="flex space-x-2">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => navigate(`/admin/companies/${record.id}`)}
          />
          <Popconfirm
            title={
              <>
                {translate(
                  "¿Está seguro de que quiere desvincular esta empresa del protocolo?"
                )}
                <br />
                {translate("Esta acción no se puede deshacer")}
              </>
            }
            okText="Si"
            cancelText="No"
            onConfirm={() => handleDelete(record)}
          >
            <Tooltip title="Eliminar" color="blur">
              <Button
                type="text"
                icon={<DeleteOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: translate("Nombre"),
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <CellButton
          onClick={() => navigate(`/admin/companies/${record.id}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </CellButton>
      ),
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {
    if (reload !== null && protocol?.id) {
      loadCompanies();
    }
  }, [reload, protocol, JSON.stringify(tableParams)]);

  const loadCompanies = async () => {
    setLoading(true);
    try {
      const res = await CompanyServices.getProtocolCompanies(protocol.id);
      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data.enterprises.length > 0
      ) {
        setData(res.data.enterprises);
        setTotal(res.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleDelete = async (enterprise) => {
    setLoading(true);
    try {
      const res = await ProtocolServices.updateProtocol({
        protocol_id: protocol.id,
        enterprises_delete: [enterprise.id],
      });
      if (res.status >= 200 && res.status < 300) {
        message.success(
          translate("La {0} se elimino exitosamente.", translate("empresa"))
        );
      } else {
        message.error(res.data.message);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey={(i) => i.id}
      loading={
        loading ? { indicator: antIcon, className: "text-custom_blue" } : false
      }
      locale={{
        emptyText: <Empty description={translate("No hay datos")} />,
        sortTitle: translate("Ordenar"),
        triggerDesc: translate("Ordenar (descendente)"),
        triggerAsc: translate("Ordenar (ascendente)"),
        cancelSort: translate("Cancelar orden"),
      }}
      pagination={{ ...tableParams.pagination, total: total }}
      onChange={handleTableChange}
    />
  );
};

ProtocolAssociatedCoTable.propTypes = {
  protocol: PropTypes.object.isRequired,
  reload: PropTypes.bool,
};

export default ProtocolAssociatedCoTable;
